import * as d3 from 'd3'

export default {

  methods: {

    draw_Summary() {

      let title = this.title
      let prog = this.progress
      
      if(title.visible !== 'Y') return
        
      let Summary = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      Summary
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', title.width)
      .attr('height', title.height)
      .attr('fill', title.boxColor)
      .attr('opacity', (title.boxOpacity) ? title.boxOpacity : 1)
      .attr('rx', title.radius).attr('ry', title.radius)

      Summary
      .append('text')
      .attr('id', `TITLE_${this.localId}`)
      .attr('x', title.width/2).attr('y', title.height/2 + title.tSize*0.4)
      .attr('fill', title.tColor).attr('font-size', title.tSize)
      .attr('text-anchor', 'middle')
      .text(title.name)

      // Progress
      if(prog.visible == 'Y') {
        Summary
        .append('text')
        .attr('x', title.width + prog.padding)
        .attr('y', title.height/2 + prog.tSize*0.4)
        .attr('fill', prog.tColor).attr('font-size', prog.tSize)
        .text(`${this.rawData.PROG}${prog.unit}`)
      }
    },

  } 
}